import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Label,
    Button
} from "reactstrap"
import { Preview } from '../../../../helpers/ui/FileInput'
import { accessRole } from '../../../../helpers/access_role'

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/penataranService'

import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import CustomSelect from '../../../../helpers/ui/CustomSelect'

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

import IndexBloc from '../Index/Blocs/DataTableBloc'
import ApproveBloc from '../Index/Blocs/IndexBloc'

import { Link, Redirect } from "react-router-dom"

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};



class DetailView extends Component {
    source
    indexBloc = new IndexBloc()
    approveBloc = new ApproveBloc()

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            domicile: 0
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }


    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.uuid,
                employee_uuid: this.peg_uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.approveBloc.fetchApprove(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        // this.indexBloc.app
        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.approveBloc.approveChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="penataran"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?penataran`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Approve Penataran</CardTitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama Penataran 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.upgrading_skill_name}
                                            </Label>
                                        </Row>
                                        <hr/>
                                        <Label># Tempat Penataran</Label>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Luar / Dalam Negeri
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                {detail?.upgrading_skill_domicile_name}
                                            </Label>
                                        </Row>
                                        { detail?.upgrading_skill_domicile == 0 ?
                                            <Fragment>
                                                <Row className="mb-2">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Provinsi
                                                    </Label>
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {detail?.upgrading_skill_province_name}
                                                    </Label>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Col md="3">
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {detail?.upgrading_skill_city_name}
                                                    </Label>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Col md="3">
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {detail?.upgrading_skill_city_name}
                                                    </Label>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }
                                        <hr/>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelanggara 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.upgrading_skill_organizer}
                                            </Label>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {reformatDate(detail?.upgrading_skill_start_date)}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {reformatDate(detail?.upgrading_skill_end_date)}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Piagam 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.upgrading_skill_charter_number}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Piagam 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {reformatDate(detail?.upgrading_skill_charter_date)}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                File Piagam 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                <Preview
                                                    value={detail?.document}
                                                />
                                            </Label>
                                        </Row>


                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="upgrading_skill_status"
                                                    errorMessage="Pilih Status Approval"
                                                    options={[
                                                        { value: 1, label: 'Disetujui' },
                                                        { value: 2, label: 'Ditolak'}
                                                    ]} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Button 
                                                    color="success" 
                                                    type="submit"
                                                >
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                {' '}
                                                <Link to={`?penataran`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin ?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diverifikasi"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diverifikasi"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/home.html?penataran`}/>
                : null }                                   



            </Fragment>
        )
    }

}

export default DetailView
